"use strict";
/**
 * @see ./README.md
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ProGalleryTypes;
(function (ProGalleryTypes) {
    ProGalleryTypes["IMAGE"] = "image";
    ProGalleryTypes["VIDEO"] = "video";
    ProGalleryTypes["TEXT"] = "text";
})(ProGalleryTypes = exports.ProGalleryTypes || (exports.ProGalleryTypes = {}));
var ProGalleryItem = /** @class */ (function () {
    function ProGalleryItem(itemId, metaData) {
        this.metaData = {
            backgroundColor: '',
            description: '',
            height: 0,
            link: { url: '' },
            title: '',
            type: undefined,
            width: 0,
        };
        this.itemId = itemId;
        if (metaData) {
            this.metaData = metaData;
        }
    }
    ProGalleryItem.prototype.addDescription = function (desc) {
        this.metaData.description = desc;
    };
    ProGalleryItem.fromJSON = function (proItem) {
        return new ProGalleryItem(proItem.itemId, proItem.metaData);
    };
    return ProGalleryItem;
}());
exports.ProGalleryItem = ProGalleryItem;
//# sourceMappingURL=ProGalleryItem.js.map